import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import pl from "./locales/pl";
import en from "./locales/en";

const storedLanguage = window.localStorage.getItem("language");
const browserLanguage = window.navigator.language?.toLowerCase().startsWith("en")
  ? "en"
  : "pl";
const initialLanguage = storedLanguage || browserLanguage;

i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    en: { translation: en },
  },
  lng: initialLanguage,
  fallbackLng: "pl",
  interpolation: {
    escapeValue: false,
  },
  returnObjects: true,
});

i18n.on("languageChanged", (language) => {
  window.localStorage.setItem("language", language);
  document.documentElement.lang = language;
});

document.documentElement.lang = initialLanguage;

export default i18n;
